const DIALOGUE_BOX_SIZE = {
  width: '60vw',
  minWidth: '390px',
  minWidthGalaxyFold: '280px'
}

export {
  DIALOGUE_BOX_SIZE
}
